import moment from "moment";

const shortcutOnClick = (numDays) => {
  return (picker) => {
    const start = moment().subtract(numDays, "days");
    const end = moment().subtract(1, "day");
    picker.$emit("pick", [start.toDate(), end.toDate()]);
  };
};

export const datePickerOptions = {
  shortcuts: [
    { text: "Last week", onClick: shortcutOnClick(7) },
    { text: "Last month", onClick: shortcutOnClick(30) },
    { text: "Last 3 months", onClick: shortcutOnClick(90) },
  ],
};
